import React from "react";
import { Loader2 } from "lucide-react";

type Variant = "accent" | "secondary" | "danger" | "ghost" | "warn";
type Size = "md" | "sm" | "xs";

const variantClass: Record<Variant, string> = {
  accent: "btn-accent",
  secondary: "btn-secondary",
  danger: "btn-danger",
  ghost: "btn-ghost",
  warn: "btn-warn"
};

const sizeClass: Record<Size, string> = {
  md: "",
  sm: "btn-sm",
  xs: "btn-xs"
};

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
  leftIcon?: React.ReactNode;
  href?: string;
};

export const Button: React.FC<ButtonProps> = ({
  variant = "accent",
  size = "md",
  loading = false,
  leftIcon,
  className = "",
  children,
  disabled,
  href,
  ...rest
}) => {
  const classes = `${variantClass[variant]} ${sizeClass[size]} ${className}`.trim();
  const content = (
    <>
      {loading ? <Loader2 size={16} className="animate-spin" /> : leftIcon}
      {children}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classes} {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={classes} disabled={disabled || loading} {...rest}>
      {content}
    </button>
  );
};
